// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"d58207a8","232":"ed81d4e1","382":"a1c138da"}[chunkId] + ".chunk.js";
};